import React from 'react';
import { ErrorComponent } from 'components/error-message/style';
import { Children } from 'utils/types/react';

interface ErrorMessageProps {
  children: Children;
}

function ErrorMessage({ children, ...props }: ErrorMessageProps) {
  return <ErrorComponent {...props}>{children}</ErrorComponent>;
}

ErrorMessage.defaultProps = {
  children: null,
};

export default ErrorMessage;
